import React from 'react'
import { Box, Text } from 'vvs-uikit'
import { useTranslation } from 'contexts/Localization'

const EarningTooltipContent = ({ vaultApr, xvvsPastWeekApr }) => {
  const { t } = useTranslation()

  return (
    <Box>
      <Text color="white" marginBottom="8px">
        {t(
          `Vault APRs are comprised of the auto compounded base APR from xVVS + the rewards from the VVS vault emission. xVVS base APR is realized once you unstake xVVS for VVS.`,
        )}
      </Text>
      <Text color="white">
        {t('xVVS APR: %apr%%', {
          apr: xvvsPastWeekApr,
        })}
      </Text>
      <Text color="white">
        {t('Vault APR: %apr%%', {
          apr: vaultApr,
        })}
      </Text>
    </Box>
  )
}

export default EarningTooltipContent
